module.exports = __webpack_public_path__ + "media/images/vp/bg.task.heart-a0c81b4824e44befab3ccbe67b737358.svg";